/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DiscoverProtectedResourceMetadataRequestBody = {
  /**
   * The ID of the remote MCP server to probe.
   */
  remoteMcpServerId: string;
};

/** @internal */
export type DiscoverProtectedResourceMetadataRequestBody$Outbound = {
  remote_mcp_server_id: string;
};

/** @internal */
export const DiscoverProtectedResourceMetadataRequestBody$outboundSchema:
  z.ZodMiniType<
    DiscoverProtectedResourceMetadataRequestBody$Outbound,
    DiscoverProtectedResourceMetadataRequestBody
  > = z.pipe(
    z.object({
      remoteMcpServerId: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        remoteMcpServerId: "remote_mcp_server_id",
      });
    }),
  );

export function discoverProtectedResourceMetadataRequestBodyToJSON(
  discoverProtectedResourceMetadataRequestBody:
    DiscoverProtectedResourceMetadataRequestBody,
): string {
  return JSON.stringify(
    DiscoverProtectedResourceMetadataRequestBody$outboundSchema.parse(
      discoverProtectedResourceMetadataRequestBody,
    ),
  );
}
